module.exports = __webpack_public_path__ + "media/yir-short2.617f21e1.webm";